let $activitiesContainer,
    $removeActivityButton;

let firstLoadActivities = true;

$(document).ready(function ($) {
    $activitiesContainer = $(".js-activities-container");
    if ($activitiesContainer.length !== 0 && firstLoadActivities) {
        getActivities();
        firstLoadActivities = false;
    }
});

function initActivityFunctions(){
    $removeActivityButton = $('.js-remove-activity');
    if (!$loaders) {
        $loaders = $('.js-loader');
    }

    $removeActivityButton.on('click', function (e) {
        $(this).html('<i class="fas fa-circle-notch fa-spin"></i>');
        e.preventDefault();
        let postId = $(this).data('postid');
        getActivities(postId);
    });
}

function getActivities(removePostId = null){
    if (!$loaders) {
        $loaders = $('.js-loader');
    }
    $loaders.addClass('is_loading');

    $.ajax({
        url: linku_ajax_url,
        type: 'post',
        data: {
            action: 'load_activities',
            remove: removePostId
        },
        dataType: 'json',
        success: function (response) {
            $activitiesContainer.html(response.activitiesHtml);
            $loaders.removeClass('is_loading');
            initActivityFunctions();
        },
        error: function (response) {
            console.log('error', response);
        }
    });
}

